import {
  MdDeviceHub,
  MdEvent,
  MdHub,
  MdLocalFireDepartment,
  MdLogin,
  MdOutlineAnalytics,
  MdOutlineDashboard,
  MdOutlineHub,
} from "react-icons/md";
import {
  AiOutlineLaptop,
  AiOutlineUser,
  AiTwotoneCamera,
} from "react-icons/ai";
import "../../styles/dashBoardStyle.css";
import { Link } from "react-router-dom";
import imglogo from "../../assets/logoTransparent.png";
import logo from "../../assets/logo-icon.png";
import { FiSliders } from "react-icons/fi";
import { GiBoxingGlove } from "react-icons/gi";
import { GiTopHat } from "react-icons/gi";
import {
  FaBuilding,
  FaCar,
  FaClipboardList,
  FaDoorOpen,
  FaTasks,
  FaThLarge,
  FaUserClock,
  FaUserPlus,
  FaUsers,
} from "react-icons/fa";
import { LiaUserClockSolid } from "react-icons/lia";
import { HiOutlineClipboardList } from "react-icons/hi";
import { useVisionContext } from "../ContextAPI/VisionContext";
import { useSelector } from "react-redux";

function SideBar() {
  const { setShowCheckInCheckOut } = useVisionContext();
  const { data } = useSelector((state) => state?.authUser?.data);
  const ramaUser = "687f6c6fc14ca8470b40b732";
  const shardaUser = "687f6cddc14ca8470b40b734";
  //console.log("data", data);
  return (
    <>
      <aside className="leftPanel">
        <div className="logo">
          <img className="lgLogo" src={imglogo} />
          <span>
            <img className="iconLogo" src={logo} />
          </span>
        </div>
        <div className="taskMenu">
          <ul>
            {data?.user_id === "687f6c6fc14ca8470b40b732" && (
              <li>
                <Link to="#">
                  <MdLogin />
                  <span>Rama-University</span>
                </Link>
                <div className="subMemuOut">
                  <ul>
                    <li>
                      <Link to="/Setlinetrack">Create Event</Link>
                    </li>
                    <li
                      onClick={() => {
                        setShowCheckInCheckOut(true);
                      }}
                    >
                      <Link to="/rama-logs"> Ativity Logs</Link>
                    </li>
                    <li>
                      <Link to="/mess-ditection">Mess Detection</Link>
                    </li>
                    <li>
                      <Link to="/rama-events">Events</Link>
                    </li>
                    <li>
                      <Link to="/rama-students">Students</Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {data?.user_id !== ramaUser && data?.user_id !== shardaUser && (
              <>
                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/camera-group">
                    <MdOutlineDashboard />
                    <span>Dashboard</span>
                  </Link>
                </li>

                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="#">
                    {" "}
                    <AiTwotoneCamera />
                    <span>Cameras</span>
                  </Link>

                  <div className="subMemuOut">
                    <ul>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/camera">Cameras</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/camera-group">Camera Group</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/device-type">Device Type</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/controllers">Device Controller</Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/employee">
                    <AiOutlineUser />
                    <span>Employees</span>
                  </Link>
                </li>

                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/reports">
                    <MdOutlineAnalytics />
                    <span>Reports</span>
                  </Link>
                </li>
                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/user-configure">
                    <FiSliders />
                    <span>User Configure</span>
                  </Link>
                </li>
                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="#">
                    <MdHub />
                    <span>UseCases</span>
                  </Link>
                  <div className="subMemuOut">
                    <ul>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/usecase">UseCase</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/usecase-mapping">UseCase Mapping</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/usecase-events">UseCase Events</Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/event">
                    <MdDeviceHub />
                    <span>Events</span>
                  </Link>
                </li>

                <li>
                  <Link to="#">
                    <MdLogin />
                    <span>CheckIn/CheckOut</span>
                  </Link>
                  <div className="subMemuOut">
                    <ul>
                      <li>
                        <Link to="/event-details">Live CheckIn/Checkout</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(true);
                        }}
                      >
                        <Link to="/checkin-checkout-record"> Records</Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="#">
                    <FaClipboardList />
                    <span>Attendence</span>
                  </Link>
                  <div className="subMemuOut">
                    <ul>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/live-attendence">Live Attendence</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/record-attendence"> Records</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/lecture-analyse">Lecture Analyze</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/Lecture-trascript-history">
                          Lecture Convertor
                        </Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/door-log">Door</Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/room">
                    <FaBuilding />
                    <span>Rooms</span>
                  </Link>
                </li>

                {/* <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/queue-waiting">
                    <FaUserClock />
                    <span>Queue Waiting</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="#">
                    <MdLogin />
                    <span>Rama-University</span>
                  </Link>
                  <div className="subMemuOut">
                    <ul>
                      <li>
                        <Link to="/Setlinetrack">Create Event</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(true);
                        }}
                      >
                        <Link to="/rama-logs"> Activity Logs</Link>
                      </li>
                      <li>
                        <Link to="/mess-ditection">Mess Detection</Link>
                      </li>
                      <li>
                        <Link to="/rama-events">Events</Link>
                      </li>
                      <li>
                        <Link to="/rama-students">Students</Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="#">
                    <FaClipboardList />
                    <span>UseCases Videos</span>
                  </Link>
                  <div className="subMemuOut">
                    <ul>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/attendance-videos">Attendance</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/checkin-checkout-videos">
                          Checkin/Checkout
                        </Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/restricted-zones-videos">
                          Restricted Zones
                        </Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/number-plate-videos">Number Plate</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/door-control-videos">Door Control</Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/lecture-analysis-videos">
                          Lecture Analysis
                        </Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/transcript-generation-videos">
                          Transcript Generation
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                {/* <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link>
                    <FaTasks />
                    <span>Usecases Events</span>
                  </Link>
                  <div className="subMemuOut">
                    <ul>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/fire-detect">
                       
                          Fire Detection
                        
                        </Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/fight-detection">
                          
                          Fight Detection
                        
                        </Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/Hat-detect">
                        
                          Hat Detection
                      
                        </Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/door-log">
                         
                          Door Detection
                     
                        </Link>
                      </li>
                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/numberplat">
                        
                          Number Plate
                        
                        </Link>
                      </li>

                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/seat-detect">
                          
                          Seat Detection
                         
                        </Link>
                      </li>

                      <li
                        onClick={() => {
                          setShowCheckInCheckOut(false);
                        }}
                      >
                        <Link to="/crowd-detection">
                       
                          Crowd Detection
                          
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li> */}
                <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/invite-user">
                    <FaUserPlus />
                    <span>Invite User</span>
                  </Link>
                </li>
                {/* <li
                  onClick={() => {
                    setShowCheckInCheckOut(false);
                  }}
                >
                  <Link to="/team-member">
                    <FaUsers />
                    <span>Team Member</span>
                  </Link>
                </li> */}
                {/* <li>-
              <a href="">
                <AiOutlineVideoCamera />
                <span>Recorded Clips</span>
              </a>
              <div className="subMemuOut">
                <ul>
                  <li>
                    <Link to="/RecoredClips">Find Clips</Link>
                  </li>
                  <li>
                    <Link to="/merged-clip">Converted Clips</Link>
                  </li>
                </ul>
              </div>
            </li> */}
                {/* <li>
              <Link to="/error-logs">
                <MdErrorOutline />
                <span>Error</span>
              </Link>
            </li> */}
              </>
            )}
            {data?.user_id === "687f6cddc14ca8470b40b734" && (
              <li>
                <Link>
                  <MdLogin />
                  <span>Sharda-University</span>
                </Link>
                <div className="subMemuOut">
                  <ul>
                    <li>
                      <Link to="/ShardaMess-detection">Mess Detection</Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}
          </ul>
        </div>
      </aside>
    </>
  );
}

export default SideBar;
